import React from 'react'
import { useState, useEffect  } from 'react';
import style from './Ranking.module.css'
import { Link } from 'react-router-dom'
import { Button } from '../../components';
import FlipMove from 'react-flip-move';
import RotateLoader from "react-spinners/ScaleLoader";

const Ranking = () => {

    const [players, setPlayers] = useState();
    const [isLoading, setIsLoading] = useState(true);

    const override = {
        display: "block",
        margin: "60px auto",
        borderColor: "red",
    };

    useEffect(() => {
        const url = 'https://quiz-laura-default-rtdb.firebaseio.com/players-laura.json';
        const options = {
            method: 'GET',
            headers: {"Content-type": "application/json"},
        };
        fetch(url, options)
            .then(response => response.json())
            .then(payload => {
                setPlayers(Object?.values(payload)?.sort((a, b) => parseFloat(b.score) - parseFloat(a.score)));
                setIsLoading(false)
            })
            .catch(error => {
                console.log(error)
            })
    }, [players]);

    return (
        <div className={style.container}>
            <h2 className={style.ranking_title}>👑 Ranking 👑</h2>
                <div className={style.ranking_container}>
                    <div className={style.ranking}>
                        <RotateLoader color={"#660099"} loading={isLoading} cssOverride={override} size={20} />

                        <FlipMove>
                            {players?.map((player, i) => (
                                <div className={style.ranking_data} key={i}>
                                    <p className={style.name}>{i === 0 ? '🥇' : ''}{i === 1 ? '🥈' : ''}{i === 2 ? '🥉' : ''} {player.name}</p>
                                    <p className={style.puntos}>{player.score}</p>
                                </div>
                            ))}
                        </FlipMove>
                    </div>
                </div>
                <Link to='/' className={style.link}>
                    <Button text='Ir al inicio'/>
                </Link> 
        </div>
    )
}

export default Ranking